/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import { useSelector } from 'react-redux';
import { Query } from '@apollo/client/react/components';
import mbpLogger from '@module-logger/mbp';

// redux, hooks, helpers

import { array } from 'prop-types';
import { selectedSkuType } from '../../common/types';
import { getBrandName } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getFeatureFlag } from '../../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';
import { GRAPHQL_ENV } from '../../../../../../gql';
import findContent from '../../../../../../gql/queries/findContent';
import ProductAttributeIconsCMS from './ProductAttributeIconsCMS';

const ProductAttributeIconsQuery = ({
    selectedSku, productAttributes,
}) => {
    const brandName = useSelector(getBrandName);
    const pdpCertificationEnabledFlag = useSelector(getFeatureFlag('is-pdp-certification-enabled'));
    if (!pdpCertificationEnabledFlag) return null;

    const contentType = 'product_attribute_icons';
    const getContentTypeData = {
        brand: brandName,
        contentType,
        GRAPHQL_ENV,
    };
    const CERTIFICATION_PAGE_QUERY = findContent(getContentTypeData);
    return (
        <Query query={CERTIFICATION_PAGE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null;
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: CERTIFICATION_PAGE_QUERY,
                        component: ' ProductAttributeIconsQuery.js',
                        message: 'Error loading snipe data from Graphql',
                        env: GRAPHQL_ENV,
                        jsError: error,
                    });
                    return null;
                }
                if (data.findContent.content?.entries?.length > 0) {
                    return <ProductAttributeIconsCMS data={data.findContent.content?.entries?.[0]} selectedSku={selectedSku} productAttributes={productAttributes} />;
                }
                return '';
            }}

        </Query>
    );
};
ProductAttributeIconsQuery.propTypes = {
    selectedSku: selectedSkuType,
    productAttributes: array,
};
ProductAttributeIconsQuery.defaultProps = {
    selectedSku: {},
    productAttributes: [],
};
export default (ProductAttributeIconsQuery);
